/**
 * DEFAULT FEATURE FLAGS - Single Source of Truth
 *
 * 🚀 This is the ONLY place where developers should add new feature flags!
 *
 * Adding a new feature flag:
 * 1. Add your flag name and default value here
 * 2. The flag will automatically appear in FEATURE_FLAGS constants
 * 3. Add to Firebase Remote Config
 * 4. Start using it in components with useFeatureFlag()
 *
 * Flag naming convention: web_[feature_name]
 * Default values: false/true for booleans, "qa"/"premium" for access control
 */
export const DEFAULT_FEATURE_FLAGS = {
  web_freeplan: false,
  web_sentimentscanner: false,
  web_records_enablePartialPrintedRecords: false,
  web_records_enableFreeUserPDFRecords: false,
  webFeatureFlagTest: false,
  web_writingassistant: false,
  web_user_property_test: 'qa',
  web_calendar_connect: false,
  web_free_tier_restriction: false,
  web_ai_suggestedPaymentRequests: false,
  web_fee_waiver: false,
  web_spanish_version: false,
  web_pay_for_coparent: false,
  web_third_party_access: false
} as const

export type FeatureFlagKey = keyof typeof DEFAULT_FEATURE_FLAGS

/**
 * Convert defaults to the format expected by Firebase Remote Config
 * Firebase expects strings, so convert booleans to string representations
 */
export function getDefaultFeatureFlagsForInterface(): Record<
  string,
  boolean | string
> {
  const converted: Record<string, boolean | string> = {}

  Object.entries(DEFAULT_FEATURE_FLAGS).forEach(([key, value]) => {
    // Convert booleans to strings for Firebase Remote Config compatibility
    converted[key] = value.toString()
  })

  return converted
}
